import { Link } from "react-router-dom";
import type { Anime } from "@/types/anime";
import { formatDate } from "@/utils/anime";

interface AnimeCardProps {
  anime: Anime;
  showRank?: number;
}

export default function AnimeCard({ anime, showRank }: AnimeCardProps) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group block w-full cursor-pointer"
      title={`${anime.title} - 色情动漫详情介绍`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200 border border-background-300/40">
        <img
          src={anime.cover}
          alt={`${anime.title} 封面`}
          title={`${anime.title} ${anime.category} ${anime.year}`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-90" />

        <span className="absolute top-2 left-2 inline-flex items-center h-6 px-2 rounded-md bg-background-50/80 backdrop-blur-sm text-[11px] text-accent-400 border border-accent-600/30">
          {anime.category}
        </span>

        <span className="absolute top-2 right-2 inline-flex items-center gap-0.5 h-6 px-1.5 rounded-md bg-background-50/80 backdrop-blur-sm text-[11px] text-foreground-900 font-label tracking-wider">
          <i className="ri-star-fill text-accent-500 text-[10px]" />
          {anime.rating.toFixed(1)}
        </span>

        {showRank && (
          <span className="absolute bottom-2 right-2 font-label text-4xl leading-none text-accent-500/80">
            {String(showRank).padStart(2, "0")}
          </span>
        )}

        <div className="absolute inset-x-0 bottom-0 p-2.5">
          <p className="text-[11px] text-foreground-500 flex items-center gap-1.5">
            <i className="ri-calendar-line" />
            {formatDate(anime.updatedAt)} 更新
          </p>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm text-foreground-900 group-hover:text-accent-400 transition-colors truncate">
          {anime.title}
        </h3>
        <p className="mt-1 text-[11px] text-foreground-500 truncate">
          {anime.region} · {anime.year} · {anime.status}
        </p>
      </div>
    </Link>
  );
}